"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var derived_exports = {};
__export(derived_exports, {
  attachmentFolderSchema: () => attachmentFolderSchema,
  featureSchema: () => featureSchema,
  isAttachmentFolderSchema: () => isAttachmentFolderSchema,
  isFeatureSchema: () => isFeatureSchema,
  isPickedSchema: () => isPickedSchema,
  isUserRefSchema: () => isUserRefSchema,
  labeledSchema: () => labeledSchema,
  pickedSchema: () => pickedSchema,
  userRefSchema: () => userRefSchema
});
module.exports = __toCommonJS(derived_exports);
var import_index = require("./index.js");
var import_create = require("./create.js");
var import_guard = require("./guard.js");
function labeledSchema(type, schema) {
  return (0, import_create.sumSchema)({ [type]: schema });
}
const userRefSchema = (0, import_create.productSchema)({
  screenName: (0, import_create.nullableSchema)(import_create.stringSchema),
  userId: (0, import_create.nullableSchema)(import_create.uuidSchema)
});
function isUserRefSchema(schema) {
  return (0, import_guard.isProductSchema)(schema) && (0, import_guard.productHasField)(schema, "screenName", (0, import_guard.isNullableSchema)(import_guard.isStringSchema)) && (0, import_guard.productHasField)(schema, "userId", (0, import_guard.isNullableSchema)(import_guard.isUuidSchema));
}
const attachmentFolderSchema = (0, import_create.productSchema)({
  folder: import_create.uuidSchema
});
function isAttachmentFolderSchema(schema) {
  return (0, import_guard.isProductSchema)(schema) && (0, import_guard.productHasField)(schema, "folder", import_guard.isUuidSchema);
}
function featureSchema(properties = import_create.unknownSchema, geometry = (0, import_create.geometrySchema)()) {
  return labeledSchema("Feature", (0, import_create.productSchema)({ geometry, properties, id: (0, import_create.nullableSchema)(import_create.stringSchema) }));
}
function isFeatureSchema(isPropertiesSchema = import_guard.isProductSchema, isFeatureGeometrySchema = (0, import_guard.isGeometrySchema)()) {
  return (0, import_guard.isLabeledSchema)(
    "Feature",
    (schema) => (0, import_guard.productHasField)(schema, "geometry", isFeatureGeometrySchema) && (0, import_guard.productHasField)(schema, "properties", isPropertiesSchema) && (0, import_guard.productHasField)(schema, "id", (0, import_guard.isNullableSchema)(import_guard.isStringSchema))
  );
}
function pickedSchema(properties = import_create.unknownSchema, geometry = (0, import_create.geometrySchema)()) {
  return (0, import_create.productSchema)({
    location: import_index.pointSchema,
    data: (0, import_create.nullableSchema)(featureSchema(properties, geometry))
  });
}
function isPickedSchema(isPropertiesSchema = import_guard.isProductSchema, isFeatureGeometrySchema = (0, import_guard.isGeometrySchema)()) {
  return (schema) => (0, import_guard.isProductSchema)(schema) && (0, import_guard.productHasField)(schema, "point", (0, import_guard.isGeometrySchema)("Point")) && (0, import_guard.productHasField)(schema, "feature", (0, import_guard.isNullableSchema)(isFeatureSchema(isPropertiesSchema, isFeatureGeometrySchema)));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  attachmentFolderSchema,
  featureSchema,
  isAttachmentFolderSchema,
  isFeatureSchema,
  isPickedSchema,
  isUserRefSchema,
  labeledSchema,
  pickedSchema,
  userRefSchema
});
//# sourceMappingURL=derived.js.map
